import type { ContainerProps } from "@chakra-ui/react";
import { Container } from "@chakra-ui/react";
import React from "react";

const SectionContainer = ({ children, ...props }: ContainerProps) => (
  <Container w="full" maxW="1200px" py="20" px={[3, 3, 4, 5]} {...props}>
    {children}
  </Container>
);

export default SectionContainer;
